import { Svg } from '@manomano-internal/tamagoshi-icons/esm/SvgOptimizer/Svg';
import { forwardRef } from 'react';

import { TamagoshiIcon } from '@/domains/core/tamagoshiv2/interfaces';

export const ArrowNextIcon = forwardRef<SVGSVGElement, TamagoshiIcon>(
  (props, ref) => (
    <Svg
      optimizationId="tama-arrow-next"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      ref={ref}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.418 11h11.17l-4.88-4.88c-.39-.39-.39-1.03 0-1.42a.996.996 0 0 1 1.41 0l6.59 6.59c.39.39.39 1.02 0 1.41l-6.59 6.59a.996.996 0 1 1-1.41-1.41l4.88-4.88H5.417c-.55 0-1-.45-1-1s.45-1 1-1Z"
        fill="currentColor"
      />
    </Svg>
  ),
);

ArrowNextIcon.displayName = 'ArrowNextIcon';
